var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailEnvelope16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5a3 3 0 013 3v5a3 3 0 01-3 3H4a3 3 0 01-3-3v-5a3 3 0 013-3h8zm1.5 4.27l-5.081 3.424a.75.75 0 01-.74.055l-.098-.055L2.5 6.77v3.73a1.5 1.5 0 001.356 1.493L4 12h8a1.5 1.5 0 001.493-1.356l.007-.144V6.77zM12 4H4a1.5 1.5 0 00-1.42 1.017l5.419 3.65 5.422-3.65a1.501 1.501 0 00-1.277-1.01L12 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06 4.897L8 9.571l6.94-4.673c.04.195.06.396.06.602v5a3 3 0 01-3 3H4a3 3 0 01-3-3v-5a3 3 0 01.06-.603z",
    fillOpacity: 0.15
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailEnvelope16);
export default __webpack_public_path__ + "static/media/mail-envelope-16.9de7ef5d.svg";
export { ForwardRef as ReactComponent };